import { render, staticRenderFns } from "./eadtlEdit.vue?vue&type=template&id=889f2d48"
import script from "./eadtlEdit.vue?vue&type=script&lang=js"
export * from "./eadtlEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports